import { MAXIMUM_ATTCHMENT_SIZE } from 'utils/constants';

export const splitFilesBySize = (encodedFiles) => {
  // Split the requests in case the size is greater than 3.5MB
  let group = 0;
  let size = 0;

  return encodedFiles.reduce((files, file) => {
    const attachment = {
      base64: file.base64,
      name: file.name,
      type: file.type,
    };

    if (file.size + size < MAXIMUM_ATTCHMENT_SIZE) {
      size += file.size;
    } else {
      group++;
      size = file.size;
    }

    files[group] = [...(files[group] || []), { ...attachment }];

    return files;
  }, []);
};
